import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto text-base font-bold" }

import { Colord } from "colord";


export default /*@__PURE__*/_defineComponent({
  __name: 'LayerAction',
  props: {
    layer: {},
    bgColor: {},
    textColor: {},
    isDefault: { type: Boolean }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "4e0d592c": (_ctx.textColor),
  "2fd00f5c": (_ctx.bgColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex justify-center items-center", [
      `aspect-square leading-tight colors`,
      _ctx.isDefault ? 'rounded-md p-[2px]' : 'rounded-full p-[2px]',
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.layer), 1)
  ], 2))
}
}

})